var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9C10.8 9 9.50002 10.3 9.50002 12C9.50002 13.7 10.8 15 12.5 15C14.2 15 15.5 13.7 15.5 12C15.5 10.3 14.2 9 12.5 9ZM22.4 11.6C20.4 6.9 16.6 4 12.5 4C8.40002 4 4.60002 6.9 2.60002 11.6C2.50002 11.9 2.50002 12.1 2.60002 12.4C4.60002 17.1 8.40002 20 12.5 20C16.6 20 20.4 17.1 22.4 12.4C22.5 12.1 22.5 11.9 22.4 11.6ZM12.5 17C9.70002 17 7.50002 14.8 7.50002 12C7.50002 9.2 9.70002 7 12.5 7C15.3 7 17.5 9.2 17.5 12C17.5 14.8 15.3 17 12.5 17Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordvisible);
export default __webpack_public_path__ + "static/media/passwordvisible.f26efc662c0f29047deb8739e21370a7.svg";
export { ForwardRef as ReactComponent };